export default function packageViewReducer( state = {}, action )
{
    switch( action.type )
    {
        case 'PACKAGE_FETCH_SUCCEEDED':
            return action.pkg;

        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/lib/reducers/package-view.js